import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, CardContent, CardTitle } from "alm-react-components";
import { useTranslation } from "react-i18next";
import { AppContext } from "../../../context/AppProvider";
import { verifySubscription } from "../../../services/subscriptions";
import {
  ActionType,
  APPROUTES,
  SubscriptionStatus,
} from "../../../assets/constants/constants";
import { apis } from "../../../services/alm";
import { getSllUser } from "../../../services/user";

const PersonalizedUpdates = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { state, dispatch } = useContext(AppContext);
  const [loading, setLoading] = useState(state.loading);
  const [subscriptionStatus, setSubscriptionStatus] = useState(
    state?.sllSubscriptionStatus
  );

  useEffect(() => {
    setLoading(state.loading);
    const checkUser= async()=>{
      // Fetching user info from ALM API
      const res = await apis.checkAlmUser();
      const result = res?.data;
      // Fetching user info from SLL API
      const sllUserInfo:any =  await  getSllUser(result.attributes.email);
      const headlessUserDetail = sllUserInfo?.data;
 
      if(headlessUserDetail?.corporateAccountId)       
        setSubscriptionStatus(true);
      else  
        callSubscription();
    }
    checkUser();

  }, []);

  const callSubscription = () => {
    verifySubscription()
      .then((res: any) => {
        if (res.status === 200) {
          if (
            res.data.subscriptionStatus === SubscriptionStatus.trial ||
            res.data.subscriptionStatus === SubscriptionStatus.active
          ) {
            dispatch({ type: ActionType.SET_SUBSCRIPTION, payload: true });
            setSubscriptionStatus(true);
          } else {
            navigate(APPROUTES.membershipFailure);
          }
        } else {
          navigate(APPROUTES.membershipFailure);
        }
        dispatch({ type: "SET_LOADING", payload: false });
      })
      .catch(() => {
        navigate(APPROUTES.membershipFailure);
      });
  };
   

  const toHome = () => {
    if (subscriptionStatus) navigate(APPROUTES.home);
  };
  return (
    <>
      {loading === false && (
          <div className="grid md:grid-cols-1 h-dvh w-full md:w-[689px] mx-auto">
            <div className=" flex flex-col items-start justify-normal dark:bg-black-900 p-5 py-32 mx:px-0 md:py-36">
              <Card className="text-base bg-fillMidGrayCard border-0 px-8 mid: pt-16 mid: pb-10 md:px-24 mx-auto">
                <CardContent className="p-0">
                  <CardTitle
                    className="text-3xl font-normal pb-10"
                    dangerouslySetInnerHTML={{
                      __html: t("PersonalizedUpdates.heading"),
                    }}
                  />

                  <ul className="space-y-5 text-left text-gray-500 dark:text-white pb-8">
                    <li className="flex items-center space-x-3 rtl:space-x-reverse">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-primary"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 16 12"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M1 5.917 5.724 10.5 15 1.5"
                        />
                      </svg>
                      <span>{t("PersonalizedUpdates.newContent")}</span>
                    </li>
                    <li className="flex items-center space-x-3 rtl:space-x-reverse">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-primary"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 16 12"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M1 5.917 5.724 10.5 15 1.5"
                        />
                      </svg>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t("PersonalizedUpdates.getCuratedContent"),
                        }}
                      />
                    </li>
                    <li className="flex items-center space-x-3 rtl:space-x-reverse">
                      <svg
                        className="flex-shrink-0 w-5 h-5 text-primary"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 16 12"
                      >
                        <path
                          stroke="currentColor"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M1 5.917 5.724 10.5 15 1.5"
                        />
                      </svg>
                      <span
                        dangerouslySetInnerHTML={{
                          __html: t("PersonalizedUpdates.programReminders"),
                        }}
                      />
                    </li>
                  </ul>
                  <Button
                    onClick={() => toHome()}
                    className="w-full h-auto py-2 text-base font-opensansSemiBold mb-5 mt-6"
                    dangerouslySetInnerHTML={{
                      __html: t("MembershipSuccess.soundsGood"),
                    }}
                  />

                  <Button
                    onClick={() => {
                      navigate("/user-settings/notification");
                    }}
                    variant={"link"}
                    className="w-full h-auto font-normal py-3 text-lg dark:text-formTextMute"
                    dangerouslySetInnerHTML={{
                      __html: t("MembershipSuccess.turnOffNotification"),
                    }}
                  />
                </CardContent>
              </Card>
            </div>
          </div>
      )}
    </>
  );
};

export default PersonalizedUpdates;
